class HTMLMarker extends google.maps.OverlayView {

    constructor(lat,lng, name, idDiv){
        super();

        this.lat = lat;
        this.lng = lng;
        this.name = name;
        this.pos = new google.maps.LatLng(lat,lng);
        this.idDiv=idDiv;

    }

    onRemove(){};

    onAdd() {
        var div = document.createElement('div');
        div.className ="circleMarker";
        div.id=this.idDiv;
        var text = document.createElement("h6");
        text.className = "text-center";
        text.textContent = this.name;
        div.appendChild(text);
        this.div = div;
    }

    draw() {
        var overlayProjection = this.getProjection();
        var panes = this.getPanes();

        var position = overlayProjection.fromLatLngToDivPixel(this.pos);
        this.div.style.left = position.x + 'px';
        this.div.style.top = position.y + 'px';
        this.div.style.position= "absolute";
        this.div.title=this.title;
        panes.markerLayer.appendChild(this.div);
    }
}

export default HTMLMarker;